import {Component, ElementRef, HostListener, Input, OnInit, ViewChild} from '@angular/core';
import {DocumentModel} from '../../../models/document.model';
import {CheckBoxOptionsBeanModel} from '../../../models/checkbox-options-bean.model';
import {OptionsHandlerService} from '../../../services/optionshandler.service';
import {StateManagerService} from '../../../services/state-manager.service';
import {CollectionsNames} from '../../../definitions/collections-names';
import {ScreenOrientation} from '@ionic-native/screen-orientation/ngx';
import {ContactModel} from '../../../models/contact.model';
import {MobileConfigurationModel} from '../../../models/mobile-configuration.model';
import {get as getLodash} from 'lodash';
import {PersistDocumentService} from '../../../services/persist-document.service';
import {ModalController, Platform} from '@ionic/angular';
import {GeneralService} from '../../../services/general.service';
import {AddContactPage} from '../../add-contact/add-contact.page';
import {SignDocumentPage} from '../../sign-document/sign-document.page';
import SignaturePad from 'signature_pad';

@Component({
    selector: 'app-signature-capture-mode',
    templateUrl: './signature-capture-mode.component.html',
    styleUrls: ['./signature-capture-mode.component.scss'],
})
export class SignatureCaptureModeComponent implements OnInit {
    @Input() document: DocumentModel;
    @ViewChild('imageCanvas') canvas: ElementRef;
    signaturePad: any;
    settingsCounter = 0;
    loading: any;
    showQuestions = 0;
    editSignatureContact: boolean;
    canvasElement: any;
    saveX: number;
    saveY: number;
    watch: any;
    selectedContact: ContactModel;
    contactsForCustomer: ContactModel[];
    mobileConfiguration: MobileConfigurationModel;
    screenLoaded: boolean;

    constructor(private optionsHandlerService: OptionsHandlerService,
                private screenOrientation: ScreenOrientation,
                private stateManagerService: StateManagerService,
                private collectionsNames: CollectionsNames,
                private persistDocumentService: PersistDocumentService,
                private modalController: ModalController,
                private generalService: GeneralService,
                private plt: Platform) {
    }

    ngOnInit() {
        console.log('Landscape: ', this.plt.isLandscape());
        console.log('portrait: ', this.plt.isPortrait());
        if (this.plt.is('android') || this.plt.is('ios')) {
            this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.LANDSCAPE);
        }
        this.mobileConfiguration = this.stateManagerService.getCollection(this.collectionsNames.MOBILECONFIGURATION);
        this.checkForSecurityQuestions();
        this.contactsForCustomer = this.stateManagerService.getCollection(this.collectionsNames.CONTACT)
            .filter(cont => cont.cust === this.document.customer.cod);
        if (!this.document.checkBoxOptionsBean) {
            this.document.checkBoxOptionsBean = new CheckBoxOptionsBeanModel();
            this.document = this.optionsHandlerService.assignOptionForNewDocument(this.document, 3); // initialize both to N/A
            this.document = this.optionsHandlerService.assignOptionForNewDocument(this.document, 6);
        } else {
            this.initializeCheckBoxesIfRequired();
        }
        this.selectedContact = this.document.contact;
        this.showQuestions = this.stateManagerService.getCollection(this.collectionsNames.MOBILECONFIGURATION).mobilehireShowQuestions;

    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.ionViewWillEnter();
    }


    ionViewWillEnter() {
        console.log('Did enter');
        this.canvasElement = this.canvas.nativeElement;
        this.signaturePad = new SignaturePad(this.canvasElement);
        this.canvasElement.width = window.innerWidth * 0.9;
        this.canvasElement.height = window.innerHeight * 0.55;
        console.log('Width Height', window.innerWidth, window.innerHeight);
        this.screenLoaded = true;
    }

    ionViewWillLeave() {
        this.screenOrientation.unlock();
        console.log(this.screenOrientation.type);
    }

    initializeCheckBoxesIfRequired() {
        if (this.document.checkBoxOptionsBean.option1 === false &&
            this.document.checkBoxOptionsBean.option2 === false &&
            this.document.checkBoxOptionsBean.option3 === false) {
            this.document = this.optionsHandlerService.assignOptionForNewDocument(this.document, 3);
        }

        if (this.document.checkBoxOptionsBean.option4 === false &&
            this.document.checkBoxOptionsBean.option5 === false &&
            this.document.checkBoxOptionsBean.option6 === false) {
            this.document = this.optionsHandlerService.assignOptionForNewDocument(this.document, 6);
        }

    }

    clearCanvas() {
        this.signaturePad.clear();
        // const ctx = this.canvasElement.getContext('2d');
        // ctx.clearRect(0, 0, this.canvasElement.width, this.canvasElement.height);
    }

    saveDocument() {
        const dataURL = this.signaturePad.toDataURL();
        console.log(dataURL);
        this.document.signatureContact = this.selectedContact;
        this.document.signature = dataURL;

        this.persistDocumentService.persistDocument(this.document);
        this.modalController.dismiss(this.document);
        this.generalService.createToast('Document Saved!');
    }

    async reviewDocument() {
        const modalAdd = await this.modalController.create({
            component: SignDocumentPage,
            cssClass: 'modal-fullscreen',
            componentProps: {
                document: this.document,
                counterSigningMode: true
            }
        });

        modalAdd.onDidDismiss().then((dataReturned) => {

        });
        return await modalAdd.present();
    }

    contactCompare(c1: ContactModel, c2: ContactModel): boolean {
        return c1 && c2 ? c1.id === c2.id : c1 === c2;
    }

    checkForSecurityQuestions() {
        if (getLodash(this.mobileConfiguration.mobilehireShowQuestions)) {
            // TODO show questions
        }
    }

    async addContact() {
        const modalAdd = await this.modalController.create({
            component: AddContactPage,
            cssClass: 'modal-fullscreen',
            componentProps: {}
        });

        modalAdd.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                this.contactsForCustomer.push(dataReturned.data);
                this.selectedContact = dataReturned.data;
            }
        });
        return await modalAdd.present();

    }

    cancelSignature() {
        this.modalController.dismiss(null);
    }
}
